export default __webpack_public_path__ + "static/media/hike.ed9928ac.svg";